import Payment from "../pages/Payment.vue"

const PaymentRoutes = [{
  path: "/payment",
  name: "پرداخت",
  component: Payment,
}
];
export default PaymentRoutes;
